import { getLeagueTypeId } from "../../Common/utils/league";
import LeagueDelete from "../../Components/League/LeagueDelete";
import { CreateEditLeagueForm } from "./form";
import { LeaguePreviewWrapper } from "./preview";
import { SubmitCTAs } from "./submit-ctas";

const CreateEditLeague = ({
  isEdit = false,
  submitEditLeagueData,
  pushDeleteLeagueDataLayer,
  pushDeleteLeaguePopupDataLayer,
  leagueId,
  leagueType,
  memberCount,
  manageAllowedOptions,
  selectedLeague,
  canEditLeague,
  editLeagueConfirmState,
}) => {
  return (
    <>
      <section className="si-league__create-edit">
        <div className="si-league__create-edit--form">
          <CreateEditLeagueForm isEdit={isEdit} canEditLeague={canEditLeague} />
        </div>
        <div className="si-league__create-edit--ctas">
          <SubmitCTAs
            isEdit={isEdit}
            submitEditLeagueData={submitEditLeagueData}
            editLeagueConfirmState={editLeagueConfirmState}
          />
        </div>
        <div className="si-league__create-edit--preview">
          <LeaguePreviewWrapper />
        </div>
      </section>
      {isEdit &&
        manageAllowedOptions.admin[
          getLeagueTypeId(selectedLeague?.league_type)
        ]?.includes("delete") && (
          <LeagueDelete
            leagueId={leagueId}
            leagueType={leagueType}
            memberCount={memberCount}
            pushDeleteLeagueDataLayer={pushDeleteLeagueDataLayer}
            pushDeleteLeaguePopupDataLayer={pushDeleteLeaguePopupDataLayer}
          />
        )}
    </>
  );
};

export default CreateEditLeague;
